/* This file is autogenerated, see readme.md for instructions */
import MobileSmsSvgIcon from '@bloomreach/banana-theme/icons/mobile-sms.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MobileSmsIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MobileSmsSvgIcon />
    </Icon>
  );
});

MobileSmsIcon.displayName = 'MobileSmsIcon';

export default MobileSmsIcon;
